import { useEffect, useState } from "react";
import { useStoreLoading } from "../../context/StoreLoadingContext";
import "./StoreSplash.css";

// Debe coincidir con la transicion de .adc-splash--saliendo en el CSS.
const SALIDA_MS = 420;

function StoreSplash() {
  const { visible } = useStoreLoading();
  const [montado, setMontado] = useState(visible);

  // Se mantiene montada durante el fundido de salida.
  useEffect(() => {
    if (visible) {
      setMontado(true);
      return;
    }
    const t = setTimeout(() => setMontado(false), SALIDA_MS);
    return () => clearTimeout(t);
  }, [visible]);

  // Bloquea el scroll del fondo mientras la pantalla esta puesta.
  useEffect(() => {
    if (!montado) return;

    const previo = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previo;
    };
  }, [montado]);

  if (!montado) return null;

  return (
    <div
      className={`adc-splash ${visible ? "" : "adc-splash--saliendo"}`}
      role="status"
      aria-live="polite"
      aria-label="Loading store"
    >
      <div className="adc-splash-inner">
        <img src="/image/ADC-Logo.png" alt="" className="adc-splash-logo" />
        <p className="adc-splash-brand">Aircraft Service &amp; Part</p>

        <div className="adc-splash-bar">
          <span />
        </div>

        <p className="adc-splash-msg">Loading store…</p>
      </div>
    </div>
  );
}

export default StoreSplash;
